/* eslint-disable @wordpress/dependency-group */
import $ from 'jquery';
import variableProductHasEmptyAttribute from '../helpers/variable-product-has-empty-attribute';
import pricesStripCurrencySymbol from '../theme/inc/prices-strip-currency-symbol';

export default function () {

	// On page load

	setTimeout(() => {
		pricesStripCurrencySymbol();
	}, 500);

	if( variableProductHasEmptyAttribute( $('.variations select') ) === true ) {
		$('.summary .price').show();
	} else {
		$('.summary .price').hide();
	}

	// On variation change

	$('.variations_form select').on('change', function (evt) {

		if( variableProductHasEmptyAttribute( $('.variations select') ) === true ) {
			$('.summary .price').show();
		} else {
			$('.summary .price').hide();
		}

		setTimeout(() => {
			pricesStripCurrencySymbol();
		}, 0);

	});
}
